import { startRendering, update } from './streams'
import { state } from './App'

function gamepadHandler(event, connecting) {
  var gamepad = event.gamepad;

  if (!connecting) {
      update(model => {
        if (model.gamepad1_index !== null && model.gamepad1_index == gamepad.index) {
            model.gamepad1_index = null
        }
        if (model.gamepad2_index !== null && model.gamepad2_index == gamepad.index) {
            model.gamepad2_index = null
        }
        return model
      })
  }
}

function checkGamepads() {
    for (let gamepad of navigator.getGamepads()) {
        if (gamepad !== null) {
        if (gamepad.mapping == 'standard') {
            if (gamepad.buttons[0].pressed && gamepad.buttons[9].pressed) {
                update(model => {
                    model.gamepad1_index = gamepad.index
                    if (model.gamepad2_index == gamepad.index) {
                        model.gamepad2_index = null
                    }
                    return model
                })
            }
            if (gamepad.buttons[1].pressed && gamepad.buttons[9].pressed) {
                update(model => {
                    model.gamepad2_index = gamepad.index
                    if (model.gamepad1_index == gamepad.index) {
                        model.gamepad1_index = null
                    }
                    return model
                })
            }
        } else if (gamepad.id.search('Logitech Gamepad F310') !== -1) {
            if (gamepad.buttons[0].pressed && gamepad.buttons[7].pressed) {
                update(model => {
                    model.gamepad1_index = gamepad.index
                    if (model.gamepad2_index == gamepad.index) {
                        model.gamepad2_index = null
                    }
                    return model
                })
            }
            if (gamepad.buttons[1].pressed && gamepad.buttons[7].pressed) {
                update(model => {
                    model.gamepad2_index = gamepad.index
                    if (model.gamepad1_index == gamepad.index) {
                        model.gamepad1_index = null
                    }
                    return model
                })
            }
        }
    }
    }
}

setInterval(checkGamepads, 1000)

window.addEventListener("gamepadconnected", function(e) { gamepadHandler(e, true) }, false)
window.addEventListener("gamepaddisconnected", function(e) { gamepadHandler(e, false) }, false)

var hidden, visibilityChange; 
if (typeof document.hidden !== "undefined") { // Opera 12.10 and Firefox 18 and later support 
  hidden = "hidden";
  visibilityChange = "visibilitychange";
} else if (typeof document.msHidden !== "undefined") {
  hidden = "msHidden";
  visibilityChange = "msvisibilitychange";
} else if (typeof document.webkitHidden !== "undefined") {
  hidden = "webkitHidden";
  visibilityChange = "webkitvisibilitychange";
}

function handleVisibilityChange() {
  if (document[hidden]) {
      state.pause(null)
  }
}

document.addEventListener(visibilityChange, handleVisibilityChange, false);

startRendering()


//////////////////
// WEBPACK FOOTER
// ./src/index.js
// module id = 11
// module chunks = 0